export class ChangePasswordModel {
    currentPassword: string;
    newPassword: string;
    newPasswordRepeat: string;
}



// WEBPACK FOOTER //
// ./src/app/models/change.password.model.ts